var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h-100" },
    [
      _c(
        "ob1-cards",
        {
          attrs: {
            "is-multiple": true,
            "is-inversed": _vm.isBlack,
            "with-composite-link": false,
          },
        },
        [
          _vm.offer.technologyLogo
            ? _c("img", {
                staticClass: "logo-5g",
                attrs: {
                  src: _vm.offer.technologyLogo,
                  alt: "logo 5G Orange",
                  "aria-hidden": "true",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showBanner(_vm.offer.banner)
            ? _c("span", {
                directives: [
                  {
                    name: "msh-html",
                    rawName: "v-msh-html",
                    value: _vm.offer.banner,
                    expression: "offer.banner",
                  },
                ],
                staticClass: "ob1-tag ob1-tag-primary card-tag fw-bold",
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "tile-content d-flex flex-column pt-2" }, [
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "title-wrapper px-1 px-xl-2 d-flex flex-column",
                },
                [
                  _c("h2", { staticClass: "visually-hidden" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.nameAccessibility) +
                        "\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "pt-xl-1 py-0 mb-0 fw-bold",
                      attrs: { "aria-hidden": "true" },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.getTitle(_vm.offer.offerType)) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "h2",
                    {
                      staticClass: "h1 py-0 mb-0",
                      attrs: { "aria-hidden": "true" },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.offer.secondaryShortLabel) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "price-wrapper",
                  class: _vm.isShowOpenDiscountMessage
                    ? "my-1 mx-1 mx-xl-2 ps-1 bg-greige"
                    : "mb-0 px-1 px-xl-2",
                },
                [
                  _vm.offer.openDiscountMessage
                    ? [
                        _c("div", {
                          directives: [
                            {
                              name: "msh-html",
                              rawName: "v-msh-html",
                              value: _vm.offer.openDiscountMessage,
                              expression: "offer.openDiscountMessage",
                            },
                          ],
                          staticClass: "fw-bold small text-dark pt-1 pb-0 pe-1",
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("Price", {
                    attrs: {
                      price: _vm.offer.price.price,
                      "initial-price": _vm.offer.price.initialPrice,
                      "price-details": _vm.offer.price.priceDetails
                        ? _vm.offer.price.priceDetails
                        : undefined,
                      "show-from": _vm.offer.price.showFrom,
                      "show-by-month": _vm.offer.price.showByMonth,
                      "show-promo-duration": _vm.offer.price.showPromoDuration,
                      "show-promo-duration-first-months":
                        _vm.offer.price.showPromoDurationFirstMonths,
                      "show-children-promotion-price":
                        _vm.offer.price.showChildrenPromotionPrice,
                      duration: _vm.offer.price.duration,
                      "is-cents-format": false,
                      "is-compact": true,
                      "is-inverse":
                        _vm.isBlack && !_vm.isShowOpenDiscountMessage,
                    },
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "claim-wrapper" }, [
                _vm.offer.claims
                  ? _c("div", { staticClass: "mx-1 mx-xl-2" }, [
                      _c(
                        "ul",
                        {
                          staticClass: "row list-unstyled",
                          attrs: { "aria-label": "Avantages du forfait" },
                        },
                        _vm._l(_vm.offer.claims, function (claim, index) {
                          return _c(
                            "li",
                            { key: index },
                            [
                              _c("offer-claim", {
                                key: index,
                                attrs: {
                                  claim: claim,
                                  "is-black": _vm.isBlack,
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "advantage-message-wrapper" }, [
                _vm.advantageOfferMobileMessage
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-row align-items-center px-1 px-xl-2",
                      },
                      [
                        _c("p", { staticClass: "mb-0 pt-0" }, [
                          _c("span", {
                            staticClass: "icon-Mobile-payment font-size-26",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "mb-0 pt-0" }, [
                          _c("span", {
                            directives: [
                              {
                                name: "msh-html",
                                rawName: "v-msh-html",
                                value: _vm.advantageOfferMobileMessage,
                                expression: "advantageOfferMobileMessage",
                              },
                            ],
                            staticClass: "fw-bold",
                          }),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex justify-content-center px-1 px-xl-2" },
              [
                _vm.isAddOfferWithPopin
                  ? _c("offer-cta-with-device-popin", {
                      staticClass: "mx-0 px-0 w-100",
                      attrs: {
                        "is-wide": true,
                        "is-primary": true,
                        "is-inverse": _vm.isBlack,
                        "from-cds": true,
                        "is-sub": _vm.isSub,
                        label: _vm.ctaLabel,
                        "offer-name": _vm.offer.name,
                        "popin-id":
                          "addOfferWithDevicePopIn-" + _vm.offer.idSeo,
                        "popin-ctas-dto":
                          _vm.offer.addOfferDto.popinWithDeviceCdsDto,
                        "tracking-category": _vm.ctaTrackingCategory,
                        "tracking-label": _vm.getLabelToTmsFormat(
                          _vm.offer.name
                        ),
                      },
                    })
                  : _vm.offer.addOfferDto
                  ? _c("ob1-boutons", {
                      attrs: {
                        "is-button": false,
                        "is-primary": true,
                        "is-inverse": _vm.isBlack,
                        "is-wide": true,
                        label: _vm.ctaLabel,
                        "aria-label": "Choisir ce " + _vm.nameAccessibility,
                        href: _vm.offer.addOfferDto.link,
                        "data-oevent-category": _vm.ctaTrackingCategory,
                        "data-oevent-action": _vm.getLabelToTmsFormat(
                          _vm.ctaLabel
                        ),
                        "data-oevent-label": _vm.getLabelToTmsFormat(
                          _vm.offer.name
                        ),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.offer.addOfferWithAuthenticationDto
                  ? _c("offer-cta-with-device-popin", {
                      staticClass: "mx-0 px-0 w-100",
                      attrs: {
                        "is-wide": true,
                        "is-primary": true,
                        "is-inverse": _vm.isBlack,
                        "from-cds": true,
                        "is-sub": _vm.isSub,
                        label: _vm.ctaLabel,
                        "offer-name":
                          _vm.offer.name + " " + _vm.offer.offerType,
                        "popin-id":
                          "addOfferWithAuthenticationAndDevicePopIn-" +
                          _vm.offer.idSeo,
                        "popin-ctas-dto":
                          _vm.offer.addOfferWithAuthenticationDto
                            .popinWithDeviceCdsDto,
                        "tracking-category": _vm.ctaTrackingCategory,
                        "tracking-label": _vm.getLabelToTmsFormat(
                          _vm.offer.name
                        ),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.offer.addOfferInCartDto
                  ? _c("ob1-boutons", {
                      staticClass: "mx-0 px-0 w-100",
                      attrs: {
                        "is-button": true,
                        "is-primary": true,
                        "is-inverse": _vm.isBlack,
                        label: _vm.offer.addOfferInCartDto.label,
                        "aria-label": "Choisir ce " + _vm.nameAccessibility,
                        "data-oevent-category": "tuile_forfait_vsim",
                        "data-oevent-action": "ajouter_au_panier",
                        "data-oevent-label": _vm.offer.name,
                      },
                      on: {
                        "ob1-boutons-click": function ($event) {
                          $event.preventDefault()
                          return _vm.onAddOfferInCart()
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-flex justify-content-center pb-1 px-1 px-xl-2",
              },
              [
                _c("ob1-liens", {
                  attrs: {
                    "is-button": "",
                    "with-arrow": true,
                    "is-inverse": _vm.isBlack,
                    "aria-label": _vm.openOffersPopinAccessibility,
                    "data-bs-toggle": "modal",
                    "data-test-id": "btn-popin-detail-" + _vm.offer.idSeo,
                    "modal-id": "offer-details-popin",
                    text: _vm.linkCdsDetailPageOrConfigureLabel,
                    "data-oevent-category": _vm.ctaTrackingCategory,
                    "data-oevent-action": _vm.getLabelToTmsFormat(
                      _vm.offer.linkCdsDetailPageLabel
                    ),
                    "data-oevent-label": _vm.getLabelToTmsFormat(
                      _vm.offer.name
                    ),
                  },
                  on: {
                    "ob1-liens-click": function ($event) {
                      return _vm.openOffersPopin(_vm.offer)
                    },
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }